import { useMutation } from '@tanstack/react-query'
import { agentLoginByPassword } from './login-by-password.service'
import type { AgentLoginByPasswordInput } from '../..'

export const useAgentLoginByPassword = () => {
  return useMutation({
    mutationFn: (data: AgentLoginByPasswordInput) => agentLoginByPassword(data),
  })
}
